const inputCreator = (key: string, value: string): HTMLInputElement => {
  const input = document.createElement<"input">("input");
  input.type = "hidden";
  input.name = key;
  input.value = value;
  return input;
};

export const classicFormSubmit = (
  url: string,
  values: { [s: string]: string | string[] },
  opts: { target?: "_self" | "_blank"; method?: "post" | "get" } = {}
) => {
  const form = document.createElement<"form">("form");
  form.target = opts.target || "_self";
  form.method = opts.method || "post";
  form.action = url;
  Object.entries(values).forEach(([k, v]) => {
    if (Array.isArray(v)) {
      v.forEach(sv => form.appendChild(inputCreator(k + "[]", sv)));
    } else {
      form.appendChild(inputCreator(k, v));
    }
  });
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
